






































































































import { Component, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import DatatableHeading from '@/components/piaf/Datatable/DatatableHeading.vue';
import VuetablePaginationBootstrap from '@/components/piaf/Common/VuetablePaginationBootstrap.vue';
import { mixins } from 'vue-class-component';
import { getResidentList, postActiveStatus, deleteResidentDetail } from '@/configs/api-path';
import { AdminRoleList } from '@/configs/role';
import CheckProjectMixin from '@/mixins/check-project';
import VuetableMixin from '@/mixins/vuetable';
import ApiStatusMixin from '@/mixins/api-status';
import ApiErrorMixin from '@/mixins/api-error';
import { VuetableSortOrder, VuetablePagination } from '@/@types/vuetable.d';
import { roleIsHigherThen } from '@/utils/role';
import { UserLogin } from '@/models/user';
import { ProjectMenu, AttachProject } from '@/models/project';
import { ResidentListItem } from '@/models/resident';

@Component({
  components: {
    DatatableHeading,
    VuetablePaginationBootstrap,
  },
})
export default class PageResidentList extends mixins(
  CheckProjectMixin, VuetableMixin, ApiStatusMixin, ApiErrorMixin,
) {
  tablePrepage = 10;

  currentProject: AttachProject | null = null;

  residentList: ResidentListItem[] = [];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataTableFields: any[] = [
    {
      name: 'name',
      title: '姓名',
      sortField: 'name',
      dataClass: 'list-item-heading',
    },
    {
      name: 'mobile',
      title: '登入手機',
      sortField: 'mobile',
    },
    {
      name: 'updated_at',
      title: '更新日期',
      sortField: 'updated_at',
    },
    {
      name: 'status--slot',
      title: '住戶狀態',
      width: '110px',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
    {
      name: 'action--slot',
      title: '操作',
      width: '198px',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
  ];

  get projectId() {
    return this.$route.params.projectId;
  }

  get filtedResidentList() {
    return this.residentList
      .filter((resident) => {
        const matchRegexp = new RegExp(this.filterKeyword === '' ? '.*' : `.*(${this.filterKeyword}).*`, 'gi');

        const matchName = resident.name.match(matchRegexp);
        const matchMobile = resident.mobile.match(matchRegexp);

        return Boolean(matchName) || Boolean(matchMobile);
      });
  }

  get breadcrumb() {
    return [
      {
        text: '住戶管理',
        to: null,
      },
      {
        text: this.currentProject?.name,
        to: null,
      },
    ];
  }

  @Getter('app/getMenuProjectsAll') getProjectMenu!: ProjectMenu[];

  @Getter('user/currentUser') currentUser!: UserLogin;

  @Watch('filtedResidentList')
  onFiltedResidentListChange() {
    this.$refs.vuetable.refresh();
  }

  testRoleIsHigher(roleCode: number) {
    return roleIsHigherThen((this.currentUser.role as AdminRoleList).code, roleCode, true);
  }

  changePageSize(size: number) {
    this.tablePrepage = size;
  }

  onChangePage(page: number) {
    this.$refs.vuetable.changePage(page);
  }

  dataManager(sortOrder: VuetableSortOrder[], pagination: VuetablePagination) {
    const tableData = this.vuetableDataManager(
      sortOrder,
      pagination,
      this.$refs.vuetable,
      this.filtedResidentList,
    );
    this.tablePagination = tableData.pagination;
    return tableData;
  }

  onPaginationData(paginationData: VuetablePagination) {
    this.$refs.pagination.setPaginationData(paginationData);
  }

  async toggleResidentStatus(nextStatus: boolean, resident: ResidentListItem) {
    this.setApiLoading();
    if (!resident.id) {
      return;
    }

    try {
      const statusData = {
        module: 2,
        targetId: resident.id,
        status: nextStatus,
      };

      const { data: residentStatusResponse } = await this.$axios.post<{
        code: number;
      }>(postActiveStatus, statusData);

      if (residentStatusResponse.code === 0) {
        this.$notify
          .show('success filled', `${resident.name}已${nextStatus === true ? '啟用' : '停用'}！`,
            `${nextStatus === true ? '啟用' : '停用'}住戶`, { duration: 3000, permanent: false });
      } else {
        const residentInList = this.residentList.find((oResident) => oResident.id === resident.id);
        if (residentInList) {
          residentInList.status = !nextStatus;
        }
        this.apiErrorCodeAlert(residentStatusResponse.code,
          `${nextStatus === true ? '啟用' : '停用'}住戶`);
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  async fetchResidentList() {
    if (!this.projectId) {
      this.$notify.show('error filled', '查無此建案', '住戶管理');
      return;
    }

    this.setApiLoading();
    try {
      const { data: residentListResponse } = await this.$axios.get<{
        code: number;
        user: ResidentListItem[];
      }>(getResidentList(this.projectId));

      if (residentListResponse.code === 0) {
        this.residentList = residentListResponse.user;
      } else {
        this.apiErrorCodeAlert(residentListResponse.code);
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  async deleteResident(resident: ResidentListItem) {
    if (!resident.id) {
      return;
    }

    const residentId = resident.id as number;
    const confirm = window.confirm(`確定刪除住戶 ${resident.name}？\n刪除後將無法復原該名住戶。`);

    if (confirm === false) {
      return;
    }

    this.setApiLoading();
    try {
      const { data: residentResponse } = await this.$axios.delete<{
        code: number;
        user: {
          id: number;
        };
      }>(deleteResidentDetail(residentId));

      if (residentResponse.code === 0) {
        this.$notify
          .show('success filled', `住戶 ${resident.name} 已刪除！`, '刪除住戶', {
            duration: 3000, permanent: false,
          });

        const residentIndexInList = this.residentList
          .findIndex((oResident) => oResident.id === residentId);

        this.residentList.splice(residentIndexInList, 1);
      } else {
        this.apiErrorCodeAlert(residentResponse.code, '刪除住戶');
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  async checkProjectAndFetch() {
    try {
      this.setApiLoading();
      const projectExist = await this.checkProjectExistII(this.projectId);
      this.setApiPending();

      if (projectExist.code === 0) {
        this.currentProject = {
          id: projectExist.project.id,
          name: projectExist.project.name,
        };

        this.fetchResidentList();
      } else {
        this.$notify.show('error filled', projectExist.message, '住戶管理');
      }
    } catch (error) {
      this.setApiPending();
      this.$notify.show('error filled', error.message, '住戶管理');
      console.error(error.message);
    }
  }

  beforeMount() {
    this.checkProjectAndFetch();
  }
}
